export class HttpError extends Error {
  status?: number;
  statusText?: string;
  url?: string;
  data?: unknown;

  constructor(message: string, response?: Response, url?: string, data?: unknown) {
    super(message);
    this.name = "HttpError";
    this.status = response?.status;
    this.statusText = response?.statusText;
    this.url = url;
    this.data = data;
  }
}
